import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { orderAutomationApi } from 'api';
import {
  OrderAutomationStatusLabel,
  DataGridColumnDefinition,
} from 'components';
import {
  FilterDefinitionType,
  OrderAutomationActiveStatus,
  OrderAutomationFilterTypes,
  QueryKey,
} from 'enums';
import { usePartialQuery, useUser } from 'hooks';
import { TranslationNamespace } from 'i18n';
import {
  FilterDefinition,
  OrderAutomationFilters,
  OrderAutomation,
} from 'types';
import { orderAutomationUtils } from 'utils';

import { ManageOrderAutomationList } from '../ManageOrderAutomationList';

export const ActiveOrderAutomation: React.FC = () => {
  const { t: tColumns } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.order_automation.table.columns',
  });

  const { role } = useUser();

  const queryResult = usePartialQuery(
    QueryKey.ActiveOrderAutomation,
    orderAutomationApi.getMessagesPaginatedAsRole(
      role,
      OrderAutomationFilterTypes.Active,
    ),
    { useCachedCount: true },
  );

  const additionalColumns = useMemo(
    (): DataGridColumnDefinition<OrderAutomation>[] => [
      {
        header: tColumns('status'),
        valueGetter: (item) => (
          <OrderAutomationStatusLabel status={item.status} />
        ),
      },
    ],
    [tColumns],
  );

  const additionalFilters: FilterDefinition<OrderAutomationFilters>[] = useMemo(
    () => [
      {
        label: tColumns('status'),
        name: 'status',
        type: FilterDefinitionType.Enum,
        enum: OrderAutomationActiveStatus,
        getDisplayName: orderAutomationUtils.getStatusLabel,
      },
    ],
    [tColumns],
  );

  return (
    <ManageOrderAutomationList
      queryResult={queryResult}
      additionalColumns={additionalColumns}
      additionalFilters={additionalFilters}
    />
  );
};
